const generateLink = (path) => {
    const baseURL = "https://api.themoviedb.org/3/movie/";  
    const apiKey = `?api_key=${process.env.REACT_APP_MOVIEDB_API}`;
    const url = baseURL + path + apiKey;

    return url;
};

export { generateLink };